import './css/AdminPageView.css';

import * as React from 'react';
import { connect } from 'react-redux';

import {
    downloadPdf,
    openDocumentById,
    getDocumentList,
    deleteDocument,
    getStatesList,
    startLoading,
    stopLoading,
    cloneDocument
  } from '../../actions/actions';
import { changeOrderStatus, getAdminOrdersList, deleteOrder, hideOrderModal, getOrderTypeCount, placeOrder } from '../../actions/orderActions';
import { IDisclaimer, IDivider, IDocument, IOrder, IUserDownloadList, IEditorState, IUserData, IState, IOrderQuantities_Addresses } from '../../infrastructure/interfaces';
import ShippingModal from '../Modals/ShippingModal/ShippingModal';
import DeleteConfirmModal from '../Modals/DeleteConfirmModal';
import ShippingInfoWarningModal from '../Modals/ShippingInfoWarningModal';
import SuccessModal from '../../components/Modals/SuccessModal';
import WarningModal from '../Modals/WarningModal/WarningModal';
import CloneDocumentModal from '../Modals/ClonedDocumentModal/CloneDocumentModal';
import SuperUserOrdersTable from '../SuperUser/components/SuperUserOrdersTable';
import Header from './components/Header';
import { Tab, Tabs } from '../../components/Tabs';
import DocumentsTable from '../../components/Home/components/DocumentsTable';
import DocumentService from '../../services/DocumentService';
import BatchDownloads from "../BatchDownloads/BatchDownloads";
import PDFDownloadModal from '../Modals/PDFDownloadModal/PDFDownloadModal';

export interface IAdminPageProps {
  openDocumentById(id: number, redirect?: string): any;
  getAdminOrdersList(startIndex: Number, listSize: Number, orderCategory: Number): void;
  deleteOrder(id: number): void;
  changeOrderStatus(order: any, statudId: number): any;
  getOrderTypeCount(status_id: number): void;
  onDownload(document: IDocument, dividers: IDivider[], disclaimers: IDisclaimer[], userData: IUserData, isPrintDownload: boolean): void;
  deleteDocument(id: number): void;
  getDocumentList(userID: string): void;
  getStatesList(): void;
  startLoading(): void;
  stopLoading(): void;
  hideOrderModal(): void;
  placeOrder(document: IDocument, user_id: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]): void;
  onCloneDocument(document: IDocument, name: string, user_id: string): void;
  orderCreated: boolean;
  currentDocument: IDocument | null;
  documentList: any[];
  editor: IEditorState;
  userData: IUserData;
  statesList: IState[];

  statuses: any[];
  orders: any[];
  userDownloadList: IUserDownloadList[];
  adminOrderTypeCount: number;
  adminOrdersList: IOrder[];
  dividers: IDivider[];
  disclaimers: IDisclaimer[];
}

export interface IAdminPageState {
  showShippingInfoWarning: boolean;
  showShippingModal: boolean;
  showDeleteOrderModal: boolean;
  showDeleteEditingDocumentModal: boolean;
  showCloneProject: boolean;
  documentToView: IDocument | null;
  orderToView: IOrder | null;
  deleteId: number;
  currentTab: number;
  documentToDownload: IDocument | null;
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    openDocumentById: (id: string, redirect?: string) => {
      dispatch(openDocumentById(id, redirect));
    },
    onDownload: (document: IDocument, dividers: IDivider[], disclaimers: IDisclaimer[],  userData: IUserData, isPrintDownload: boolean) => {
      dispatch(downloadPdf(document, dividers, disclaimers, userData, isPrintDownload));
    },
    getDocumentList: (userID: string) => {
      dispatch(getDocumentList(userID));
    },
    deleteDocument: (id: number) => {
      dispatch(deleteDocument(id));
    },
    getAdminOrdersList: (startIndex: Number, listSize: Number, orderCategory: Number) => {
      dispatch(getAdminOrdersList(startIndex, listSize, orderCategory));
    },
    getOrderTypeCount: (status_id: number) => {
        dispatch(getOrderTypeCount(status_id))
    },
    onCloneDocument: (document: IDocument, name: string, userID: string) => {
      dispatch(cloneDocument(document, name, userID));
    },
    changeOrderStatus: (order: any, statusId: number) => {
      dispatch(changeOrderStatus(order, statusId));
    },
    deleteOrder: (order: IOrder) => {
      dispatch(deleteOrder(order));
    },
    getStatesList: () => {
      dispatch(getStatesList());
    },
    startLoading: () => dispatch(startLoading()),
    stopLoading: () => dispatch(stopLoading()),
    placeOrder: (document: IDocument, user_id: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
        dispatch(placeOrder(document, user_id, username, user_email, comments, orderQuantitiesAddresses));
    },
    hideOrderModal: () => {
        dispatch(hideOrderModal());
    },
  };
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.user.data,
    statuses: state.options.statuses,
    currentDocument: state.document,
    editor: state.editor,
    documentList: state.documentList,
    orderCreated: state.orderCreated,
    orders: state.adminOrdersList,
    userDownloadList: state.userDownloadList,
    statesList: state.statesList,
    adminOrderTypeCount: state.adminOrderTypeCount,
    adminOrdersList: state.adminOrdersList,
    disclaimers: state.wizard.disclaimers,
    dividers: state.wizard.dividers,
  };
};

const ordersPerPage = 10;
const initialOrderCategoryID = 2;

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class AdminPageView extends React.Component<IAdminPageProps, IAdminPageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentTab: 0,
      showShippingInfoWarning: false,
      showShippingModal: false,
      showDeleteOrderModal: false,
      showDeleteEditingDocumentModal: false,
      showCloneProject: false,
      documentToView: null,
      orderToView: null,
      deleteId: -1,
      documentToDownload: null
    };
    this.onDeleteOrder = this.onDeleteOrder.bind(this);
  }

  componentDidMount() {
    if (!this.props.adminOrdersList || (this.props.adminOrdersList.length == 0)) {
      this.props.getAdminOrdersList(0, ordersPerPage, initialOrderCategoryID);
    }
    this.props.getStatesList();
    this.props.getDocumentList(this.props.userData.id);
  }

  changeTab = (tab: number) => this.setState({ currentTab: tab });

  changeStatus = (order: IOrder, statusId: number) => {
    this.props.changeOrderStatus(order, statusId);
  }

  showShippingModal = (doc: IDocument, order: IOrder) => {
    this.setState({
      showShippingModal: true,
      documentToView: doc,
      orderToView: order,
    });
  }

  closeModal = () => {
    this.setState({
      showShippingInfoWarning: false,
      showShippingModal: false,
      showDeleteOrderModal: false,
      showCloneProject: false,
      showDeleteEditingDocumentModal: false,
      documentToDownload: null
    });
  }

  onCloneDocumentLocal = (document: IDocument | null, name: string) => {
    if (document !== null){
      this.props.onCloneDocument(document, name, this.props.userData.id)
    }
  }

  editDocument(doc: IDocument) {
    this.props.openDocumentById(doc.id, '/Editor');
  }

  editDocumentByNumber = (documentId: number) => {
    this.props.openDocumentById(documentId, '/Editor');
  }

  onDeleteOrder(id: any) {
    this.setState({
      showDeleteOrderModal: true,
      deleteId: id,
    });
  }

  deleteDocument = (id: number) => {
    if ((this.props.currentDocument != null) && (this.props.currentDocument.id === id)) {
      this.setState({ showDeleteEditingDocumentModal: true });
      return;
    }
    this.props.deleteDocument(id);
  }

  onDownload = (document: IDocument) => {
    this.setState({ documentToDownload: document });
  }

  onDownloadPDFWithCropMarks = (value: boolean) => {
    if (this.state.documentToDownload) {
      this.props.onDownload(this.state.documentToDownload, this.props.dividers, this.props.disclaimers, this.props.userData, value);
      this.setState({ documentToDownload: null });
    }
  }

  onSaveDocument = (document: IDocument, userID: string) => {
    DocumentService.saveDocument(document, userID);
  }

  onOpenOrdersPreview = (document: IDocument) => {
    this.setState({ showShippingInfoWarning: true, documentToView: document });
  }

  onOpenCloneProject = (document: IDocument) => {
    this.setState({ showCloneProject: true, documentToView: document});
  }

  onOrderSubmit = (document: IDocument, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {

    this.setState({ showShippingInfoWarning: false, documentToView: null});
    this.props.startLoading();

    DocumentService
      .saveDocument(document, this.props.userData.id)
      .then(() => {
        this.props.placeOrder(document, this.props.userData.id, this.props.userData.email, this.props.userData.username, comments, orderQuantitiesAddresses);
      })
      .catch(error => console.error(error));
  }

  render() {

    const {
      currentDocument,
      documentList,
      userData,
      userDownloadList,
      editor,
      statesList,
      orderCreated,
      adminOrderTypeCount,
      adminOrdersList
    } = this.props;

    return (
      <div className="root-container">
        <Header />

        <div className="superUser-container">
          <Tabs
              tabsContainerClassName="su-page-tab-wrapper"
              tabBodyClassName="su-page-tab-body"
              tabClassName="su-page-tab"
              activeTabClassName="su-page-tab-active"
              currentTab={this.state.currentTab}
              onTabChanged={this.changeTab}
          >
            <Tab title="Review/Approve Orders">
              <SuperUserOrdersTable
                onDownloadPdf={ this.onDownload }
                adminOrderTypeCount={adminOrderTypeCount}
                orders={adminOrdersList}
                editDocument={doc => this.editDocument(doc)}
                viewDocument={(doc: IDocument, order: IOrder) => this.showShippingModal(doc, order)}
                statuses={this.props.statuses}
                changeStatus={this.changeStatus}
                userDownloadList={userDownloadList}
                onDeleteOrder={this.onDeleteOrder}
                getOrderTypeCount={this.props.getOrderTypeCount}
                getAdminOrdersList= {this.props.getAdminOrdersList}
                ordersPerPage={ordersPerPage}
                initialOrderCategoryID={initialOrderCategoryID}
                dividers={this.props.dividers}
                disclaimers={this.props.disclaimers}
              />
            </Tab>
            <Tab title="Manage Projects">
                <DocumentsTable
                    documents={documentList}
                    documentInProgress={currentDocument}
                    editor={editor}
                    onEditDocument={this.editDocumentByNumber}
                    onDeleteDocument={this.deleteDocument}
                    onDownload={this.onDownload}
                    onOpenOrdersPreview={this.onOpenOrdersPreview}
                    onOpenCloneProject={this.onOpenCloneProject}
                    userData={userData}
                    userDownloadList={userDownloadList}
                />
            </Tab>
            <Tab title="Batch Downloads">
              <BatchDownloads/>
            </Tab>
          </Tabs>
        </div>

        {/* Modals */}
        <SuccessModal
          show={orderCreated}
          onClose={() => this.props.hideOrderModal()}
          title={'Thank you for your order.'}
          successMessage={<span>All orders will be received within 14 Business Days.</span>}
        />
        <WarningModal
          show={this.state.showDeleteEditingDocumentModal}
          warningMessage="You can't delete the document being edited."
          onClose={this.closeModal}
        />
        <ShippingInfoWarningModal
          document={this.state.documentToView}
          userData={userData}
          show={this.state.documentToView && this.state.showShippingInfoWarning}
          onClose={() => this.setState({ showShippingInfoWarning: false, documentToView: null })}
          onPlaceOrder={this.onOrderSubmit}
          valid={true}
          statesList={statesList}
        />
        <ShippingModal
          show={this.state.showShippingModal}
          onClose={this.closeModal}
          order={this.state.orderToView}
        />
        <DeleteConfirmModal
          show={this.state.showDeleteOrderModal}
          onClose={this.closeModal}
          onSave={() => {
            this.props.deleteOrder(this.state.deleteId);
            this.closeModal();
          }}
          title="Delete order?"
        />
        <PDFDownloadModal
          show={ (this.state.documentToDownload != null) }
          onClose={ this.closeModal }
          onDownload={ this.onDownloadPDFWithCropMarks }
        />
        <CloneDocumentModal
          show={this.state.showCloneProject}
          onCloneDocument={(name: string) => {
            this.setState({ showCloneProject: false})
            this.onCloneDocumentLocal(this.state.documentToView, name)
          }}
          onClose={() => this.setState({ showCloneProject: false })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPageView.tsx